import { isAccessDeniedError } from '../errors/AccessDeniedError';
import { isDataverseEntityMissingError } from '../errors/DataverseEntityMissingError';

export function handleDataverseLoadError(error, navigate) {
  // Only a 401 (no/expired session) means the user is not in this kommune.
  // A 403 on one table (telefon/nøkkelforespørsel) must stay on the page.
  if (isAccessDeniedError(error) && error.status === 401) {
    navigate('/ingen-tilgang');
    return true;
  }

  return false;
}

export function getDataverseErrorMessage(error, fallback) {
  if (isDataverseEntityMissingError(error)) {
    return error.message;
  }

  if (error?.message) {
    return error.message;
  }

  return (
    fallback ||
    'Kunne ikke hente data fra Dataverse. Sjekk tilgang og at OpenCare-løsningen er importert.'
  );
}
